module.exports = __webpack_public_path__ + "img/b_LbNorm_front.89691ede.jpeg";